import styled from 'styled-components';
import NameChangeSuccessSvg from '../../assets/mytrips/name-change-success.svg';

const NameChangeSuccessIcon = styled(NameChangeSuccessSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '21rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default NameChangeSuccessIcon;
